import { makeStyles } from '../../../styles';
const ARROW_SIZE = 24;
function getArrowRotation(position) {
    switch (position) {
        case 'top':
            return 180;
        case 'bottom':
            return 0;
        case 'left':
            return 90;
        case 'right':
            return -90;
        default:
            return 0;
    }
}
export const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3),
        borderRadius: theme.spacing(1),
        boxShadow: '0 0 24px rgba(63, 63, 68, 0.12)',
        overflow: 'visible',
        marginTop: ({ position }) => {
            if (!['top', 'bottom'].includes(position)) {
                return 0;
            }
            return ((+theme.spacing(1).slice(0, -2) + ARROW_SIZE) *
                (position === 'top' ? -1 : 1));
        },
        marginLeft: ({ position }) => {
            if (!['left', 'right'].includes(position)) {
                return 0;
            }
            return ((+theme.spacing(1).slice(0, -2) + ARROW_SIZE) *
                (position === 'left' ? -1 : 1));
        },
        '&::before': {
            content: '""',
            height: ARROW_SIZE,
            width: ARROW_SIZE,
            position: 'absolute',
            backgroundColor: 'inherit',
            display: ({ position }) => position === 'center' ? 'none' : 'block',
            boxShadow: '0 0 24px rgba(63,63,68,0.12)',
            clipPath: 'polygon(-50% -50%, 150% -50%, 100% 0%, 100% 5%, 5% 100%, 0% 100%, -50% 150%)',
            transform: (props) => `rotate(${getArrowRotation(props.position) + 45}deg)`,
            top: ({ position }) => {
                if (['left', 'right'].includes(position)) {
                    return `calc(50% - ${ARROW_SIZE / 2}px)`;
                }
                return position === 'bottom' ? -(ARROW_SIZE / 2) : 'auto';
            },
            bottom: ({ position }) => position === 'top' ? -(ARROW_SIZE / 2) : 'auto',
            left: ({ position }) => {
                if (['top', 'bottom'].includes(position)) {
                    return `calc(50% - ${ARROW_SIZE / 2}px)`;
                }
                return position === 'right' ? -(ARROW_SIZE / 2) : 'auto';
            },
            right: ({ position }) => position === 'left' ? -(ARROW_SIZE / 2) : 'auto',
        },
    },
}));
//# sourceMappingURL=Popover.styles.js.map